import { useEffect, useState } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { getInstallations } from 'src/bff';
import { DealersData, DomainAttributesValues, Installation, InstallationResponse, Points } from 'src/types';
import { useIsComerciales } from './use-is-comerciales';

export function useGetInstalaciones(token: string): string {
  const dispatch = useDispatch();
  const [dealerName, setDealerName] = useState(null);
  const store = useStore()

  useEffect(() => {
    const requestInstallations = async () => {
      const installationsResponse = await getInstallations(token);
      // La respuesta viene como una array de arrays de attributes. Eliminamos este nivel para simplificar.
      const installationsDomainAtt: DomainAttributesValues[][] = installationsResponse.map((inst) => inst.attributes);
      const isComerciales = useIsComerciales();
      const selectedCarlineCode = store.getState().dealersInfo?.selectedCarline?.code;
      const excludedInstallationCodes = ['03812', '03394', 'EX1Q2', '0311X', '0321C', 'EX2C3', 'EX2H4', '30559', '53V50', '0310W', '30724', '03917', '30083', 'EX2Y1', 'EX1P0', '03910']
      const isIdBuzz = () => selectedCarlineCode === 72005 || selectedCarlineCode === 72006;

      let points: Points[] = [];
      let installations: Installation[] = [];

      installationsDomainAtt.forEach((installation) => {
        const newInstallation: Installation = {
          Id: '',
          TXT_V_Installation_Data_Name__c: '',
          FRML_TXT_codVentaProvincia__c: '',
          TXT_V_Location__c: '',
          TXT_V_Address__c: '',
          TXT_V_Postal_Code__c: '',
          TXT_V_Installation_Code__c: '',
          MPCK_Instalation_Type__c: '',
          TXT_V_KVPS_code__c: '',
          TXT_Code_Concession__c: '',
          Longitude__c: '',
          Latitude__c: '',
        };

        installation.forEach((property) => {
          const { name, value } = property;

          if (newInstallation.hasOwnProperty(name)) {
            newInstallation[name] = value;
          }
        });

        if (
          !newInstallation.Latitude__c ||
          !newInstallation.Latitude__c ||
          newInstallation.Latitude__c === '' ||
          newInstallation.Longitude__c === ''
        ) {
          return;
        }

        // Necesario para el correcto funcionamiento del mapa.
        const dealer: Partial<DealersData> = {
          kvps: newInstallation.TXT_V_KVPS_code__c,
          name: newInstallation.TXT_V_Installation_Data_Name__c,
          markerInfo: {
            dealerInfo: {
              name: newInstallation.TXT_V_Installation_Data_Name__c,
              address: newInstallation.TXT_V_Address__c,
              zipCode: newInstallation.TXT_V_Postal_Code__c,
              city: newInstallation.TXT_V_Location__c,
              province: '',
            },
          },
        };

        const point = {
          type: 'Feature',
          properties: { cluster: false, installation: newInstallation, dealer }, //concesionId: dealer.id, dealer: dealer
          geometry: {
            type: 'Point',
            coordinates: [newInstallation.Longitude__c, newInstallation.Latitude__c],
          },
        };

        const isExcludedInstallation = (): boolean => {
          return excludedInstallationCodes.includes(newInstallation.TXT_V_Installation_Code__c)
        }
        if(isComerciales && !isIdBuzz() && isExcludedInstallation()){
          return
        }
        else {
          points.push(point);
          installations.push(newInstallation);
        }
      });
      dispatch({ type: 'SET_INSTALLATIONS', payload: installations });
      dispatch({ type: 'SET_POINTS', payload: points });
      dispatch({ type: 'DEALERS_OR_INSTALLATIONS_MODE', payload: 'installations' });
    };

    requestInstallations();
  }, []);
  return dealerName;
}
